export const put_hash = (key, value) => ({
  type: 'PUT_HASH',
  key,
  value,
});

export const put_temp_hash = (key, value, hash) => ({
  type: 'PUT_TEMP_HASH',
  key,
  value,
  hash,
});

export const get_value_hash = (key) => {
  return (dispatch, getState) => {
    return getState().hash[key]?.value;
  };
};
